import { HStack, VStack, Text, Box } from "@chakra-ui/react";
import { AvatarInitials } from "../ui";
import { useAuth } from "../../features/auth/hooks/useAuth";

export default function SidebarUserCard() {
  const { perfil } = useAuth();
  const nome = perfil?.nome_completo || "Médico(a) PJ";
  const especialidade = perfil?.especialidade;

  return (
    <Box borderTop="1px solid" borderColor="app-border" pt={4} px={1}>
      <HStack spacing={3}>
        <AvatarInitials name={nome} />
        <VStack align="flex-start" spacing={0} overflow="hidden">
          <Text fontSize="sm" fontWeight="semibold" noOfLines={1}>
            {nome}
          </Text>
          <Text fontSize="xs" color="app-muted-fg" noOfLines={1}>
            PJ{especialidade ? ` · ${especialidade}` : ""}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
